import {EnvAppInfoContainer} from '@hconnect/uikit'
import React from 'react'
import Content from '../Molecules/Content'

export const Version: React.FC = () => (
  <Content style={{textAlign: 'center'}}>
    <EnvAppInfoContainer />
  </Content>
)
